const templateUrl = require('./payment-dropdown.html');

const app = angular.module('msi.payments.dropdown', [])
  .component('ogPaymentSelect', {
    templateUrl: templateUrl,
    controller: require('./payment-dropdown.controller'),
    bindings: {
      onChange: '&',
      ngModel: '<',
      payments: '<ogPayments'
    }
  });

module.exports = app.name;
